import {LayerContext} from '@dropbox/dig-components/layer';
import {growthbookCacheAtom} from 'atoms/growthbook';
import {showSearchAtom} from 'atoms/search';
import {GlobalSearchBox} from 'components/search/box/GlobalSearchBox';
import {SearchInput} from 'components/search/Search';
import {useAtomValue} from 'jotai';
import {MutableRefObject} from 'react';

import styles from './LoggedInPage.module.css';

/**
 * The overlay's own z-index (`.overlay`), so the box's tooltips and menus,
 * which DIG portals out at z-index 1 by default, draw above it.
 */
const SEARCH_OVERLAY_LAYER_Z_INDEX = 50;

/**
 * The app's search overlay, while search is open: the relaunched box with
 * `ask_relaunch`, today's box without it. `overlayRef` is the box's wrapper,
 * so a click outside it closes search.
 */
export const SearchOverlay = ({
  overlayRef,
}: {
  overlayRef: MutableRefObject<HTMLDivElement | null>;
}) => {
  const showSearch = useAtomValue(showSearchAtom);
  const {isAskRelaunchEnabled} = useAtomValue(growthbookCacheAtom);

  if (!showSearch) {
    return null;
  }

  return (
    <div className={`${styles.overlay}${isAskRelaunchEnabled ? ` ${styles.overlayTall}` : ''}`}>
      {isAskRelaunchEnabled ? (
        <div ref={overlayRef} className={styles.searchBoxWrapper}>
          <LayerContext.Provider value={{zIndex: SEARCH_OVERLAY_LAYER_Z_INDEX}}>
            <GlobalSearchBox />
          </LayerContext.Provider>
        </div>
      ) : (
        <div ref={overlayRef} className={styles.searchWrapper}>
          <SearchInput />
        </div>
      )}
    </div>
  );
};
